import { apiClient } from "./apiClient";
import { logger } from "./logger";

export interface UserProfile {
  user_id: string;
  email: string;
  name: string | null;
  phone: string | null;
  country: string | null;
  city: string | null;
  address: string | null;
  profile_completed: boolean;
}

export interface UpdateUserProfileRequest {
  name?: string;
  phone?: string;
  country?: string;
  city?: string;
  address?: string;
}

export async function getUserProfile(): Promise<UserProfile> {
  try {
    const response = await apiClient.get<UserProfile>("/user/profile");
    return response.data;
  } catch (error) {
    logger.error("Error fetching user profile:", error instanceof Error ? error : new Error(String(error)));
    throw error;
  }
}

export async function updateUserProfile(data: UpdateUserProfileRequest): Promise<UserProfile> {
  try {
    const response = await apiClient.put<UserProfile>("/user/profile", data);
    return response.data;
  } catch (error) {
    logger.error("Error updating user profile:", error instanceof Error ? error : new Error(String(error)));
    throw error;
  }
}
